import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-origin-destination-popup',
  templateUrl: './origin-destination-popup.component.html',
  styleUrls: ['./origin-destination-popup.component.scss']
})
export class OriginDestinationPopupComponent implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
